// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__mVIYM","input":"Search_input__klILD","christ":"Search_christ__IK6NV","leftStrike":"Search_leftStrike__2lnf7","rightStrike":"Search_rightStrike__pKo5H"};